<script lang="ts">
  import {t} from '../i18n'
  import {modal} from '../stores/modal'
  import Login from './Login.svelte'
  import Register from './Register.svelte'
  import FacebookButton from './FacebookButton.svelte'
  import ModalTemplate from '../shared/ModalTemplate.svelte'
  import GoogleButton from '../../src/authentication/GoogleButton.svelte'

  function openLogin(e: Event) {
    e.preventDefault()
    modal.show(Login)
  }

  function openRegister(e: Event) {
    e.preventDefault()
    modal.show(Register)
  }
</script>

<ModalTemplate size="tiny">
  <div class="modal-content">
    <div>
      <h2 class="reg-log-title">
        <span>{t.authorization.login.title}</span>

        <a class="register-btn" onclick={openRegister}>
          {t.authorization.registration.title}
        </a>
      </h2>

      <div class="login-buttons-container">
        <GoogleButton class="ui button black soc-log-btn">
          <i class="icon-p-google"/>
          <span>{t.authorization.login.google}</span>
        </GoogleButton>

        <FacebookButton class="ui button black soc-log-btn">
          <i class="icon-p-facebook"/>
          <span>{t.authorization.login.facebook}</span>
        </FacebookButton>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <span class="email-login-link">
      <a class="email-login" onclick={openLogin}>
        {t.authorization.login.with_email}
      </a>
    </span>
  </div>
</ModalTemplate>
